export enum CompanyStatus {
    active = 1,
    blocked = 2,
    registrationPending = 3,
    registrationSubmitted = 4,
    registrationRejected = 5,
    offPlatform = 6,
} 
